import { useEffect, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";

import TableWrapper from "@/components/Table/TableWrapper";
import TablePagination from "@/components/Table/TablePagination";
import { AppIcon } from "@/components/Icon";
import statementHistorySchema from "@/components/Table/schemas/statement_history";
import SupportSection from "@/pages/LMS/dashboard/support_section";
import { getStatementEntries } from "@/services/loanservices";

export function LoanTransactions() {
  const { loanUUID } = useOutletContext();
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (!loanUUID) return;
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await getStatementEntries(loanUUID);
        setAllRows(res?.results?.rows || []);
        setCurrentPage(1);
      } catch {
        setAllRows([]);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [loanUUID]);

  const totalEntries = allRows.length;
  const start = (currentPage - 1) * pageSize;
  const paginatedRows = allRows.slice(start, start + pageSize);

  const handlePageChange = (page) => {
    if (page >= 1) setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    const maxPage = Math.max(1, Math.ceil(totalEntries / size));
    setCurrentPage((p) => Math.min(p, maxPage));
  };

  return (
    <Container fluid>
      <h1 className="text-2xl fw-bolder my-4">Transactions History</h1>

      <Row className="g-3">
        <Col xs={12} md={9}>
          <div className="bg-white rounded-lg p-4" style={{ minHeight: "100%" }}>
            <Stack gap={2}>
              <TableWrapper
                tableData={paginatedRows}
                columnSchema={statementHistorySchema}
                isLoading={loading}
              />

              {!loading && allRows.length === 0 && (
                <div className="text-center py-5 text-muted">
                  <AppIcon name="Document" size={36} className="mb-2 opacity-50" />
                  <div className="fw-semibold">No transactions available</div>
                </div>
              )}

              {totalEntries > 0 && (
                <TablePagination
                  totalEntries={totalEntries}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </Stack>
          </div>
        </Col>

        <Col xs={12} md={3} className="align-self-start">
          <SupportSection />
        </Col>
      </Row>
    </Container>
  );
}
